import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import theme from './theme'; 
import { ThemeProvider } from '@mui/material/styles';

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import toWebComponent from "react-to-webcomponent";
customElements.define("mon-calendrier-component", toWebComponent(App, React, ReactDOM));

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
    <App />
    </ThemeProvider>
  </StrictMode>
);
